import { Component, Input, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { SubmitFormHowItWorks } from 'src/app/modules/institutional/models/how-it-works-data';
import { FormsService } from 'src/app/modules/institutional/services/forms.service';
import { BaseFormComponent } from 'src/app/utils/forms/base-form.component';

@Component({
    selector: 'app-unavailability-form',
    templateUrl: './unavailability-form.component.html',
    styleUrls: ['./unavailability-form.component.scss'],
    standalone: false
})
export class UnavailabilityFormComponent extends BaseFormComponent implements OnInit {
	@Input() address: any;
	isPending: boolean = false;
	success: boolean = false;
	constructor(
		private formsService: FormsService,
		private fb: UntypedFormBuilder
	) {
		super();
	}

	ngOnInit(): void {
		this.form = this.fb.group({
			name: ['', [Validators.required]],
			email: ['', [Validators.required]],
		}) as UntypedFormGroup;
	}

	submit() {
		this.isPending = true;

		let body: SubmitFormHowItWorks = {
			name: this.form.value.name,
			email: this.form.value.email,
			origin: 'PORTAL',
			localization: `${this.address}`,
		};

		this.formsService.submitUserProspect(body).subscribe({
			next: (result: any) => {
				this.isPending = false;
				this.success = true;
			},
			error: err => {
				this.isPending = false;
			},
		});
	}
}
